import { get, map } from "lodash";

import { omitTypename } from "src/util/graphql";
import { getImageAttribute } from "src/util/group";

import { SEARCH_LIMIT, unsplash } from "./ImagePicker.config";

export const unsplashSearch = async (query, page = 1) => {
  const result = await unsplash.search.getPhotos({
    query,
    page,
    perPage: SEARCH_LIMIT,
    orientation: "landscape",
    content_filter: "low",
    featured: true,
  });
  if (result.errors) {
    return { error: result.errors[0] };
  }
  return {
    data: get(result, "response.results", []),
  };
};

export const createOrAddImageAttribute = ({
  attributes = [],
  bgImgUrl,
  altDescription,
  attributeId = "bgImg",
  subtype,
}) => {
  const imageToInsert = {
    id: attributeId,
    label: altDescription,
    value: bgImgUrl,
    attributeType: "image",
    subtype,
  };
  const existingImageAttribute = getImageAttribute(attributes);

  if (!existingImageAttribute) {
    return omitTypename([...attributes, imageToInsert]);
  }

  return omitTypename(
    map(attributes, (attribute) =>
      attribute.attributeType === existingImageAttribute.attributeType
        ? imageToInsert
        : attribute
    )
  );
};

export const getSourceTypeKey = (source) => {
  switch (source) {
    case "stock_images":
      return { imgUrl: "urls.regular", altKey: "alt_description" };
    case "company_images":
      return { imgUrl: "fileKey", altKey: "name" };
    default:
      return { imgUrl: "fileKey", altKey: "name" };
  }
};
